import * as React from "react"
import { Container } from "react-grid-system"
import { HorizontalSpacer } from "../../atoms/spacers"
import Card from "../../atoms/Card"
import H1 from "../../atoms/typography/H1"
import Subtitle from "../../atoms/typography/Subtitle"
import BodyLarge from "../../atoms/typography/BodyLarge"
import { Link } from "react-router-dom"
import H3 from "../../atoms/typography/H3"

const RentalTermsPage: React.FunctionComponent = () => {
  React.useEffect(() => {
    document.title = "Rental Service Terms"
  }, [])

  return (
    <div>
      <HorizontalSpacer spacing={2} />
      <Container>
        <Card>
          <div style={{ padding: "2rem" }}>
            <HorizontalSpacer spacing={2} />
            <H1>Satcube Instant – Rental Service Terms</H1>
            <HorizontalSpacer spacing={1} />
            <Subtitle>Applicable to the Satcube terminal rental service including data capacity</Subtitle>
            <HorizontalSpacer spacing={2} />

            <Subtitle>Rental terms</Subtitle>
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                1. These rental service terms (the <b>“Rental Terms”</b>) shall apply to all offers and orders for
                Rental Services (as defined below) that may be made by (or on behalf of) the relevant company or entity
                (<b>“Company”</b>) and accepted by Satcube AB (<b>“Satcube”</b>). These Rental Terms constitute an
                integral part of the agreement between the Company and Satcube. Deviations from the Rental Terms shall
                not become binding unless agreed to in writing between the parties.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                2. Satcube is a company incorporated under the laws of Sweden with its office located at Nellickevägen
                22, 412 63 Göteborg, Sweden, with official registration number 556701-2769.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Definitions</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                3. In addition to the other terms defined elsewhere in these Rental Terms, the following definitions
                shall apply:
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>
                  a. <b>“Order Confirmation”</b> means an email from Satcube to the Company accepting an order for
                  Rental Services made by or on behalf of the Company.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. <b>“Product”</b> means the Terminal and any other products that may be set out in an Order
                  Confirmation, all substitutions, replacements and renewals of such products and all related
                  accessories, manuals and instructions provided for them.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. <b>“Rental Period”</b> means the rental period set out in the relevant Order Confirmation (as may
                  be extended from time to time through further Order Confirmation(s)). them.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  d. <b>“Rental Services” </b>means any and all services that may be provided by Satcube pursuant to any
                  Order Confirmation, which may include (without limitation): (i) rental of Product(s); (ii) enabling
                  access to the internet through a Terminal; (iii) training services in respect of a Product; and (iv)
                  access to the Site.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  e. <b>“Site”</b> means Satcube’s online site, whether made available on or through Satcube’s website
                  (www.satcube.com) or such other domain, platform or application as Satcube may use from time to time.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  f. <b>“Terminal”</b> means a Satcube Ku satellite terminal, as made available by Satcube from time to
                  time.
                </BodyLarge>
              </div>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Service descriptions and illustrations</Subtitle>
            <HorizontalSpacer spacing={1} />

            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                4. Any descriptions or illustrations on the Site are provided for the sole purpose of giving an
                approximate idea of the services described in them. They will not form part of the contract between the
                Satcube and the Company nor have any contractual force.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Order process</Subtitle>
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                5. The Company may place an online order for the Rental Services available on the Site from time to
                time, and each order is an offer by the Company for the Rental Services specified in the order subject
                to these Rental Terms. The Company is responsible for ensuring that:
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>
                  a. its order (including relevant details submitted by the Company) is complete and accurate;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>b. it cooperates with Satcube in all matters relating to the Rental Services;</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>c. it complies with all applicable laws in placing an order for Rental Services.</BodyLarge>
              </div>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                6. Satcube may acknowledge receipt of the Company’s order but this does not mean that the order has been
                accepted. Satcube’s acceptance of the Company’s order takes place when Satcube sends an Order
                Confirmation to the Company, at which point and on which date <b>(“Commencement Date”)</b> the contract
                between Satcube and the Company shall come into existence (which shall be subject to the terms and
                conditions of these Rental Terms). The contract will relate only to those Rental Services confirmed in
                the Order Confirmation.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                7. If Satcube cannot accept the Company’s order for any reason, Satcube will inform the Company by email
                and, to the extent that Satcube has already paid for relevant Rental Services, Satcube shall refund the
                relevant amount to the Company.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Rental service</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                8. Satcube shall provide Rental Services to the Company in accordance with an Order Confirmation, namely
                that:
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>a. Satcube shall rent the relevant Products to the Company;</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. in respect of rental of a Terminal, Satcube shall enable access to the internet through such
                  Terminal;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. Satcube may provide training to the Company’s personnel (for example, in relation to use of the
                  Terminal following an Order Confirmation) in accordance with Satcube’s training program in place from
                  time to time; and
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  d. Satcube shall provide the Company with access to the Site, in order for the Company to view
                  information regarding the Company’s rental(s) and to order additional Products and/or data capacity,
                </BodyLarge>
              </div>
              <HorizontalSpacer spacing={1} />
              <BodyLarge>
                in each case for the Rental Period and subject to the terms and conditions of these Rental Terms.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Delivery</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                9. Unless otherwise agreed in writing between Satcube and the Company, the Products specified in an
                Order Confirmation shall be delivered by Satcube or a third party provider at a service point in Sweden
                as may be appointed by Satcube from time to time.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Time for delivery, delay</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                10. Satcube may in the Order Confirmation make an estimate of the date when delivery of a Product can be
                made. However, Satcube does not warrant that delivery will be made at a certain specified date or at the
                expiry of a certain period of time. Satcube will notify the Company of the actual delivery date in
                sufficient time prior thereto (the <b>“Delivery Date”</b>).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>11. The risk for the goods shall pass to the Company on the Delivery Date.</BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                12. If it becomes apparent that the Delivery Date will occur later than 3 days from the date estimated
                in the Order Confirmation, Satcube shall without undue delay notify the Company thereof in writing,
                stating the reason therefor and if possible the time when delivery can be expected.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                13. If the Delivery Date has been prolonged by more than 7 days from the date estimated in the Order
                Confirmation, for reasons attributable to Satcube, then the Company may rescind the relevant order in
                respect of the goods that are in delay. Other than the Company’s right of termination pursuant to the
                foregoing sentence, all other claims in respect of a delay on the part of Satcube is hereby excluded.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                14. If the Company is unable to accept delivery of the Products on the Delivery Date, or if delay on its
                part is likely to occur, the Company shall without undue delay notify Satcube thereof in writing,
                stating the reason for the delay and if possible the time when delivery can be accepted. Regardless of
                whether the Company can accept delivery on the Delivery Date or not, the Company is obliged to make full
                payment for the Rental Services (including for rental of the Products) by the time that the Products are
                ready for delivery pursuant to Clause 10.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                15. Satcube may rescind the Order Confirmation in respect of the Products which are ready for delivery
                but in respect of which delivery has not been accepted by the Company. If Satcube rescinds the Order
                Confirmation, Satcube shall also be entitled to compensation for damages. Cancellation or rescheduling
                of the delivery by the Company may be subject to additional charges by Satcube.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Internet access</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                16. Rental of a Terminal in accordance with an Order Confirmation shall enable the Company to access the
                internet through the Terminal, subject to the other provisions of these Rental Terms. The Company
                acknowledges that the relevant internet access/data capacity may be provided by Satcube through a third
                party.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                17. Satcube does not represent, warrant nor guarantee that access to the internet through the Terminal
                will always be available, uninterrupted or error-free. Further, Satcube does not represent, warrant nor
                guarantee the performance of the internet or that the transmission of information over the internet will
                be secure or that the internet will be accessible at all times or at the data capacity or speeds
                indicated by an Order Confirmation.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                18. In the event that the Company is unable to connect to the internet from a Terminal being rented
                under an Order Confirmation, the Company shall promptly notify Satcube and Satcube shall use reasonably
                practicable endeavours to rectify the outage (which may include Satcube informing the relevant third
                party service provider of such outage).
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Site and user account</Subtitle>
            <HorizontalSpacer spacing={1} />

            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                19. Upon an Order Confirmation, the Company shall be registered with an account with Satcube (
                <b>“Account”</b>) (if the Company does not have an existing account with Satcube).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                20. The Company may use its Account to log into Satcube’s Site, access further information about its
                products and services, and order certain products and services that Satcube may make available from time
                to time, subject to the other provisions of these Rental Terms.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                21. Satcube may update and change the Site from time to time, including (without limitation) regarding
                any products, services and pricing that may be made available on the Site.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                22. Any order or purchase of goods and/or services from the Site will be subject to further terms and
                conditions (which shall be notified to the Company prior to the placing of its order or purchase).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                23. If the Company’s user(s) choose, or are provided with, a user identification code, password or any
                other piece of information as part of Satcube’s security procedures, the Company shall treat such
                information as confidential and shall not disclose it to any third party.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                24. Satcube reserves the right to disable any user identification code or password (whether chosen by
                the Company’s user(s) or allocated by Satcube) and to restrict the Company’s access to its Account, the
                Site and/or internet access through the Terminal if, in Satcube’s opinion, the Company has failed to
                comply with any provision of these Rental Terms.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                25. If the Company knows or suspects that anyone other than its authorised users knows the Company’s (or
                Company’s users’) identification code or password, the Company must promptly notify Satcube (see the
                Contact section below).
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Prohibited uses</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                26. The Company may use the Products, Rental Services, Account and the Site only for lawful purposes.
                The Company may not use any of the Products, Rental Services, Account and/or the Site:
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>a. in any way that breaches any applicable law or regulation;</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. in any way that is unlawful or fraudulent or has any unlawful or fraudulent purpose or effect;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. in respect of the Terminal, in any location where the use of satellite technology is not permitted;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  d. to transmit, or procure the sending of, any unsolicited or unauthorised advertising or promotional
                  material or any other form of similar solicitation (e.g. spam);
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  e. to transmit, send or upload any data or material that contains any virus, malware or harmful
                  programs or codes designed to adversely affect or interfere with the operation of any computer
                  software, hardware, files, data or other information (<b>“Malicious Software”</b>), whether or not
                  wilfully or negligently transmitted, sent or uploaded;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  f. to gain unauthorised access to any user account, the Site, the server on which the Site is stored
                  or any server, computer or database whether or not connected to the Site.
                </BodyLarge>
              </div>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Availability</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                27. Satcube does not represent, warrant nor guarantee that access to the Account or the Site (including
                any content therein) will always be available, uninterrupted or error-free.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                28. Satcube may suspend, withdraw or restrict the availability of all or any part of the Products,
                Rental Services, Account or the Site for business and operational reasons.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                29. Other than as expressly set out in these Rental Terms, Satcube makes no representation, warranty nor
                guarantee that: (a) the content in the Account or the Site is accurate, complete or up-to-date; and/or
                (b) the Products, Rental Services, Account and/or the Site (or any content therein) is appropriate for
                use or is available in any location outside of Sweden. The Company is responsible for configuring its
                devices and information technology to access the Site and to connect to the Terminal.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                30. Satcube does not represent, warrant nor guarantee that the Products, Rental Services, Account or
                Site will be secure or free from Malicious Software. The Company should use its own virus protection
                software.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Links to third party sites and content</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                31. Where the Site contains links to other sites and resources provided by third parties, such links are
                provided for information only. Such links should not be interpreted as approval by Satcube of those
                linked websites or information that the Company may obtain from them. Satcube has no control over the
                contents of those sites or resources. The Site may include information and materials uploaded by other
                users of the Site. Such information and materials have not been verified or approved by Satcube. The
                views expressed by other users on our Site do not represent Satcube’s views or values.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Prices, payment</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                32. Payment shall be made according to the Satcube’s current price list applicable at the time of the
                Order Confirmation. All prices are exclusive of any VAT or additional taxes and charges (such as,
                without limitation, import duties or other levies and insurance and transport costs). If no payment
                terms have been agreed, Satcube will invoice the full amount payable for the Rental Services upon
                issuance of the Order Confirmation. No Products will be shipped before full payment is received by
                Satcube.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                33. If the Company fails to make payment within 30 days of a demand by Satcube to pay any sum due,
                Satcube may rescind the contract pursuant to the Order Confirmation in part or in its entirety through
                written notice to the Company. If Satcube rescinds such Order Confirmation, Satcube shall also be
                entitled to compensation for damages. Satcube also has the right to interest on any overdue payments in
                accordance with applicable law.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Title, risk and insurance</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                34. The Products shall at all times remain the property of Satcube, and the Company shall have no right,
                title or interest in or to the Products (save the right to possession and use of the Products subject to
                the terms and conditions of these Rental Terms).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                35. The risk of loss, theft, damage or destruction of the Products shall pass to the Company on the
                Delivery Date. The Products shall remain at the sole risk of the Company during the Rental Period and
                any other term during which the Products are in the possession, custody or control of the Company{" "}
                <b>(“Risk Period”)</b> until such time as the Products are redelivered to Satcube. During the Rental
                Period and the Risk Period, the Company shall, at its own expense, obtain and maintain the following
                insurances:
              </BodyLarge>
              <HorizontalSpacer spacing={1} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>
                  a. insurance of the Products to a value not less than its full replacement value comprehensively
                  against all usual risks of loss, damage or destruction by fire, theft or accident, and such other
                  risks as Satcube may from time to time nominate in writing;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. insurance for such amounts as a prudent owner or operator of the Products would insure for, or such
                  amount as Satcube may from time to time reasonably require, to cover any third party or public
                  liability risks of whatever nature and however arising in connection with the Products; and
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. insurance against such other or further risks relating to the Products as may be required by law,
                  together with such other insurance as Satcube may from time to time consider reasonably necessary and
                  advise to the Company.
                </BodyLarge>
              </div>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                36. The Company shall give immediate written notice to Satcube in the event of any loss, accident or
                damage to any Product arising out of or in connection with the Company's possession or use of such
                Product.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                37. If the Company fails to effect or maintain any of the insurances required under these Rental Terms,
                Satcube shall be entitled to effect and maintain the same, pay such premiums as may be necessary for
                that purpose and recover the same as a debt due from the Company.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                38. The Company shall, on demand, supply copies of the relevant insurance policies or other insurance
                confirmation acceptable to Satcube and proof of premium payment to Satcube to confirm the insurance
                arrangements.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Company's responsibilities</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>39. The Company shall during the Rental Period:</BodyLarge>
              <HorizontalSpacer spacing={1} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>
                  a. ensure that each Product is kept and operated in a suitable environment, used only for the purposes
                  for which it is designed, and operated in a proper manner by trained competent staff in accordance
                  with any operating instructions provided by Satcube;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. take such steps (including compliance with all safety and usage instructions provided by Satcube)
                  as may be necessary to ensure, so far as is reasonably practicable, that each Product is at all times
                  safe and without risk to health when it is being set, used, cleaned or maintained by a person at work;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. make no alteration to any Product and shall not remove any existing component (or components) from
                  any Product;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>d. keep Satcube fully informed of all material matters relating to all Products;</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  e. maintain operating and maintenance records of the Products and make copies of such records readily
                  available to Satcube, together with such additional information as Satcube may reasonably require;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  f. not, without the prior written consent of Satcube, part with control of (including for the purposes
                  of repair or maintenance), sell or offer for sale, underlet or lend any Product or allow the creation
                  of any mortgage, charge, lien or other security interest in respect of it;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  g. not do or permit to be done any act or thing which will or may jeopardise the right, title or
                  interest of Satcube in any Product and;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  h. not suffer or permit any Product to be confiscated, seized or taken out of its possession or
                  control under any distress, execution or other legal process, but if any Product is so confiscated,
                  seized or taken, the Company shall notify Satcube and the Company shall at its sole expense use its
                  best endeavours to procure an immediate release of the Product and shall indemnify Satcube on demand
                  against all losses, costs, charges, damages and expenses incurred as a result of such confiscation;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>i. not use any Product for any unlawful purpose;</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  j. deliver up the Products at the end of the Rental Period or on earlier termination of the contract
                  pursuant to the Order Confirmation, at such address as Satcube requires or, if necessary, allow
                  Satcube or its representatives access to the site or any premises where the Products are located for
                  the purpose of removing the Products; and
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  k. not do or permit to be done anything which could invalidate the insurances referred to above.
                </BodyLarge>
              </div>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                40. The Company acknowledges that Satcube shall not be responsible for any loss of or damage to any
                Product arising out of or in connection with any negligence, misuse, mishandling of the Product or
                otherwise caused by the Company or its officers, employees, agents and contractors, and the Company
                shall indemnify Satcube in full against all liabilities, costs, expenses, damages and losses (including
                any direct, indirect or consequential losses, loss of profit, loss of reputation and all interest,
                penalties and legal costs (calculated on a full indemnity basis) and all other professional costs and
                expenses) suffered or incurred by Satcube arising out of, or in connection with any failure by the
                Company to comply with the terms of the contract pursuant to the Order Confirmation including these
                Rental Terms.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                41. In the event of any loss of or damage to any Terminal during the Rental Period, and without
                prejudice to any other rights and remedies of Satcube, the Company shall pay Satcube compensation in the
                amount of USD 30 000 (thirty thousand US dollars).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                38. The Company shall, on demand, supply copies of the relevant insurance policies or other insurance
                confirmation acceptable to Satcube and proof of premium payment to Satcube to confirm the insurance
                arrangements.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Warranty for Defects</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                42. Satcube warrants that a Product shall comply with the relevant product description made available by
                Satcube to the Company (the <b>“Product Sheet”</b>). Satcube shall, in accordance with the provisions of
                Clauses 43 to 48 below, rectify defects in the delivery which consists of Products failing to meet the
                Product Sheet (in design, workmanship or material) and which arise within a period of twelve (12) months
                from the Delivery Date in case of new products and six (6) months from delivery for any repairs or
                replacements (each a <b>“Defect”</b>).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                43. Satcube is not liable for defects arising out of material provided by the Company, a design
                stipulated, specified or requested by the Company, faults resulting from viruses or other external
                assaults or caused by third parties. Deviations from the Product Sheet which are insignificant for the
                intended use of the Products and which do not inconvenience the Company, shall not constitute any
                liability on the part of Satcube. Furthermore, Satcube’s liability does not cover defects which arise
                after the risk of the Products has passed to the Company (including any defect due to or accelerated by
                (a) conditions of operation deviating from those anticipated in these Rental Terms or otherwise
                recommended by Satcube, (b) improper use of the Products, (c) faulty or poor maintenance, (d) incorrect
                installation or handling of the Products, (e) alterations, interference or modifications to the Products
                made without Satcube’s prior written consent or (f) faulty repairs not approved by Satcube). For the
                avoidance of doubt, Satcube’s liability does not cover normal wear and tear or general deterioration.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                44. In order to be able to claim that any Product has a Defect, the Company must notify Satcube without
                undue delay after the Defect has appeared and in no case later than two (2) weeks after the expiry of
                the warranty period set out in Clause 42. Following the expiry of such period, Satcube shall have no
                liability for a Defect. If there is reason to believe that a Defect may cause damage, notice shall be
                given immediately by the Company. If notice is not so given, Satcube shall not be liable for any damage
                which could have been avoided if such notice had been timely given.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                45. Subject to the above, Satcube agrees to repair or replace, at its sole discretion, without charge,
                such Products which have a Defect and which are returned to Satcube’s appointed service point for repair
                or replacement. The Company shall bear all cost and the risk related to such transport. After receipt of
                the goods, Satcube shall – if Satcube determines that the Products have a Defect – remedy or replace
                such defective Products without undue delay.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                46. If the Company gives such notice as referred to in Clause 44, and no Defect is found for which
                Satcube is liable, the Company shall reimburse Satcube for the work and costs incurred as a result of
                the Company’s notice.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                47. If a repair or replacement of a Defect requires intervention in other equipment, the Company shall
                be solely responsible for any work or costs caused by or incurred in connection therewith.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                48. Following repair or replacement, Satcube shall be responsible for returning the Products to the
                place of original delivery as referred to in Clause 9. Any replacement to replace a Product that has a
                Defect shall be the property of Satcube, unless otherwise agreed in writing.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Indemnification</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                49. The Company shall indemnify and hold Satcube harmless against any loss, damage or cost arising out
                of or in connection with the Company’s use of the Rental Services (including, without limitation, use
                the Products) and for which Satcube is not liable pursuant to this Agreement. The Company further
                assumes the entire responsibility and liability for, and agrees to indemnify and hold Satcube harmless
                from and against any and all losses, expenses, costs, damages (including consequential and incidental
                damages), demands, liabilities, suits and claims in connection with or arising out of any actual or
                alleged personal injury (including death) or damage or destruction to property (including loss of use)
                by whomsoever suffered, sustained or alleged to have been sustained by reason of (i) any act, error or
                omission, whether negligent or not, of the Company or anyone for which the Company is responsible,
                provided that such injury, death, damage or destruction is not occasioned by the sole negligence of
                Satcube or (ii) any failure of the Company or anyone for which the Company is responsible to comply with
                any applicable law.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Intellectual property rights</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                50. All intellectual property rights and other rights, including without limitation patents, design
                rights, trademarks, copyright and know how, whether subsisting now or in future, anywhere in the world,
                relating to the Rental Services (including without limitation the Products and the Site) and any and all
                documentation related thereto are the exclusive property of Satcube (or its licensors).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                51. Nothing in the contract pursuant to the Order Confirmation including these Rental Terms shall
                constitute or be construed as a transfer of ownership of any of Satcube’s intellectual property rights
                or other rights or to otherwise give the Company any proprietary rights to the Satcube’s intellectual
                property rights.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                52. Product and technical information. All drawings, specifications and other technical documents
                relating to the Products or the manufacturing thereof, including but not limited to software delivered
                or embedded in the Products (if any) or designed for use in or together with the Products (the{" "}
                <b>“Product Data”</b>), shall remain the property of Satcube or its licensors. Satcube grants the
                Company a non-exclusive, non-sub-licensable, non-transferable license to use the Product Data in
                connection with the intended use of the Products. The Product Data may under no circumstances be used
                for any other purpose. No part of the Product Data may be copied, modified, reproduced, disassembled,
                transmitted or otherwise communicated to a third party. Satcube may terminate this license upon notice
                for violation of any of the terms of the license. Satcube shall on or by the Delivery Date provide one
                or the higher agreed number of the current user manual (if any) to the Company. Satcube is not obliged
                to supply any other documentation in relation to the Products.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Intellectual property infringement</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                53. Satcube shall indemnify and hold the Company harmless against any loss, damage or cost arising out
                of suits against the Company for infringement by the Products of any third party intellectual property
                rights, provided that the Company has used the Products only in accordance with Satcube’s instructions
                or directions and:
              </BodyLarge>
              <HorizontalSpacer spacing={1} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>
                  a. notifies Satcube immediately in writing of any allegation of such infringement;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. makes no admission of liability and does not agree to any settlement or compromise relating to the
                  alleged infringement; and
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. allows Satcube to conduct all negotiations and proceedings and give Satcube all reasonable
                  assistance in all such negotiations and proceedings relating to the alleged infringement.
                </BodyLarge>
              </div>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                54. The preceding clause notwithstanding, Satcube shall have no liability for any claim based upon or
                arising out of the (a) combination, operation, or use of any Product or associated software in a manner
                for which it was not designed nor contemplated; or (b) any modification of any equipment or associated
                software by the Company or any third party that causes the Product or associated software to become
                infringing.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                55. Clauses 53 and 54 contain Satcube’s entire obligations with respect to any infringements of
                intellectual property rights.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Anti-corruption and export control</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                56. The Company shall comply with applicable laws and regulations relating to anti-corruption, including
                without limitation, (i) the Swedish anti-corruption legislation; and (ii) the United States Foreign
                Corrupt Practices Act (FCPA).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                57. The Company acknowledges that the goods may be subject to EU, US and other applicable sanctions and
                export and import control laws, rules and regulations <b>(“Export Control Laws”)</b>, and the Company
                agrees to comply at all times with such Export Control Laws. Without limiting the foregoing, the Company
                shall not, directly or indirectly, provide, sell or otherwise transfer any part of the Products, Product
                Data or any direct product thereof in violation of applicable Export Control Laws. The Company is
                responsible for securing all necessary export control licenses and/or authorization for the goods, as
                required.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                58. The Company shall notify Satcube if any deliverable under this Agreement is restricted by applicable
                Export Control Laws. The Company shall provide in writing to Satcube the export classification of any
                such item or controlled data and shall notify Satcube in writing of any changes to the export
                classification information of the item or controlled data.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                59. The Company shall be responsible for all losses, costs, claims, causes of action, damages,
                liabilities and expense, including attorneys' fees, all expense of litigation and/or settlement, and
                court costs, arising from any act or omission of the Company, its officers, employees, agents,
                suppliers, or subcontractors at any tier, in the performance of any of its obligations under Clauses 56
                to 58.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Limitation of Liability</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                60. Notwithstanding anything to the contrary set out herein, Satcube’s total aggregate liability arising
                pursuant to or in connection with any Order Confirmation and/or these Rental Terms shall be limited to
                an amount corresponding to the lower of: (a) 15% of the amounts paid by the Company for the Rental
                Services; and (b) USD 200 000 (two hundred thousand US dollars). Satcube will only be liable for direct
                costs and will under no circumstances be liable for any indirect or consequential damages, including but
                not limited to loss of revenue, loss of profits, business or anticipated savings or any other indirect
                damage or loss of data. Furthermore, Satcube is never liable for the Company’s liability towards a third
                party. The limitation of liability set out in this Clause does not apply in the event of willful intent
                or gross negligence on the part of Satcube.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                61. To the fullest extent permissible by law, Satcube excludes all implied conditions, warranties and
                representations that may apply to the provision or use of any Product, the Rental Services, the Site and
                the Account (including any content therein).
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Personal data</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                62. When ordering Rental Services, the Company and/or its employees will be asked to provide certain
                information including personal data about individuals. Please see our{" "}
                <Link to="/privacy_policy" target="_blank" rel="noopener noreferrer">
                  <H3>Privcy Policy</H3>
                </Link>{" "}
                for further information and more information about individuals’ rights regarding their data. The Company
                can also contact Satcube (see contact information below) if the Company should have any questions
                regarding Satcube’s processing of personal data.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Confidentiality</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                63. Each party hereby undertakes to maintain in absolute confidence any confidential information
                (including but not limited to the Product Data) disclosed by the other party in connection with the
                contract pursuant to the Order Confirmation, and not to disclose any such confidential information thus
                received to any third parties. The contents of such Order Confirmation shall also be considered as
                confidential information.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Termination</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                64. Without prejudice to any remedy Satcube may have against the Company for breach or non-performance
                by the Company relating to these Rental Terms, Satcube shall have the right to terminate the contract
                pursuant to the Order Confirmation by giving the Company not less than thirty (30) days' notice in
                writing if: (a) the Company is in breach of its obligations relating to these Rental Terms and fails to
                remedy such breach within fifteen (15) days after notice; or (b) the Company has taken general measures
                to cease payment of its debts, initiated negotiations for a general agreement with its creditors, been
                subject to an application for bankruptcy proceedings or enters into composition, reorganization or
                similar arrangements with its creditors or ceases to carry on business or is wound up or goes into
                liquidation or has a receiver appointed for all or any part of its assets.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                65. At the expiration or termination of the relevant contract pursuant to the Order Confirmation for
                whatever reason, the Company shall cease all use of the Rental Services and immediately return to
                Satcube all Products as well as all information provided by Satcube hereunder.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Non-waiver </Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                66. No consent or waiver, express or implied, by either party of any breach or default of the other
                party in performing its obligations under or in connection with these Rental Terms shall be deemed or
                construed to be a consent or waiver of any other breach or default by the other party of the same or any
                other obligation hereunder. Any failure by one party to complain of any act or failure to act of the
                other party or to declare that other party in default shall not constitute a waiver by the first party
                of its rights under or in connection with these Rental Terms. No waiver of any rights under or in
                connection with these Rental Terms under this Agreement shall be effective unless in writing and signed
                by the party purporting to give the same.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Transfer of rights</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                67. Satcube may transfer its rights and obligations under these Rental Terms to any third party at any
                time. The Company shall not transfer its rights and obligations under these Rental Terms without
                Satcube’s prior written consent.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Legal relationship</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                68. Nothing in these Rental Terms will constitute or be deemed to constitute a partnership, an
                employment relationship or an agency between the parties. The Company does not have the authority to act
                on behalf of Satcube in any matter whatsoever, nor enter into any agreement or bind Satcube in any other
                way without Satcube’s prior written consent.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                69. Neither party will be liable or responsible for any acts, defaults or omissions of the other party
                or the other party’s employees or contractors.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Applicable law and disputes </Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                70. Any order for Rental Services, any Order Confirmation and these Rental Terms shall be governed by
                Swedish law, without application of its conflict of law principles.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                71. Any dispute, controversy or claim arising out of or in connection with any order for Rental
                Services, any Order Confirmation and/or these Rental Terms shall be settled in general courts, with
                Stockholms tingsrätt as the first instance.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Contact</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                72. If you have any questions regarding an order for Rental Services or these Rental Terms, please
                contact us at info@satcube.com or on +46 (0) 31 701 05 00 insert telephone number. Formal notice in
                relation to any Order Confirmation or these Rental Terms must be sent in writing to the address set out
                in Clause 2.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
          </div>
        </Card>
        <HorizontalSpacer spacing={2} />
      </Container>
    </div>
  )
}

export default RentalTermsPage
